module.exports = __webpack_public_path__ + "prod/1.42.2/img/fenxiao-six.0d3e0d6c.png";